module.exports = __webpack_public_path__ + "img/Strandtänzerin.2bbe6187.svg";